import * as React from 'react';
import './OrdersToolbar.css';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import { connect } from 'react-redux';
import OrdersFilterSelected from '../../application/order/events/OrdersFilterSelected';
import OrdersFilterRemoved from '../../application/order/events/OrdersFilterRemoved';
import Dropdown from '../common/Dropdown';
import { Filter, FilterType } from '../../domain/Filter';
import State from '../../application/core/State';
import OrderProductsSearchRequested from '../../application/order/events/OrderProductsSearchRequested';
import Search from '../search/Search';
import close from './close.svg';
import { ChangeEvent } from 'react';

interface Props {
    orderFilters: Filter[];
}

interface StateProps {
    brand: string[];
    season: string[];
    collaboration: string[];
    category: string[];
    type: string[];
    querySearch: string;
}

interface FilterViewModel {
    name: string;
    type: FilterType;
    text: string;
    value: boolean;
}
class OrdersToolbar extends React.PureComponent<Props & DispatchProps & StateProps> {
    private filters: FilterType[] = ['season', 'collaboration']; // ['brand', 'season', 'collaboration', 'category', 'type'];

    public render(): JSX.Element {
        const filters: FilterViewModel[] = [
            {
                name: 'stock',
                text: 'Products in stock',
                type: 'inStock',
                value: this.checkFilterValue('inStock')
            },
            {
                name: 'estimations',
                text: 'My estimation',
                type: 'myEstimations',
                value: this.checkFilterValue('myEstimations')
            },
            {
                name: 'liability',
                text: 'Liability not met',
                type: 'withoutLiabilityMet',
                value: this.checkFilterValue('withoutLiabilityMet')
            }
        ];
        return (
            <div className="orders-toolbar">
                <div className="orders-toolbar-container">
                    <div className="orders-toolbar-dropdown-container">
                        {this.filters.map((filter: FilterType) => {
                            return (
                                <Dropdown
                                    key={filter}
                                    placeholder={filter.charAt(0).toUpperCase() + filter.slice(1)}
                                    // tslint:disable:jsx-no-lambda
                                    onChange={this.filterChanged(filter)}
                                    options={this.props[filter]}
                                    class="toolbar-select"
                                    color="green"
                                />
                            );
                        })}
                    </div>
                    {filters.map(
                        (filter: FilterViewModel): JSX.Element => (
                            <div className="orders-toolbar-checkbox-container" key={filter.name}>
                                <input
                                    type="checkbox"
                                    id={filter.name}
                                    name={filter.name}
                                    checked={filter.value}
                                    onChange={this.checkboxFilterChanged(filter.type)}
                                />
                                <label htmlFor="stock">{filter.text}</label>
                                <span className="orders-toolbar-checkbox-checkmark" />
                            </div>
                        )
                    )}
                    <Search onSearch={this.onSearch} value={this.props.querySearch} />
                </div>
                <div className="orders-toolbar-filters">
                    {this.props.orderFilters.length > 0
                        ? this.props.orderFilters.map((filter: Filter) => {
                              if (typeof filter.value === 'string') {
                                  return (
                                      <div className="orders-toolbar-filter" key={filter.value} onClick={this.removeFilter(filter)}>
                                          <span>{filter.value}</span>
                                          <img src={close} />
                                      </div>
                                  );
                              }
                              return null;
                          })
                        : null}
                </div>
            </div>
        );
    }

    private checkFilterValue = (filterName: string): boolean =>
        this.props.orderFilters.filter(filter => filter.type === filterName).length > 0;

    // tslint:disable:typedef
    private filterChanged = (filterType: FilterType) => (selectedOption: HTMLSelectElement['value']): void =>
        this.props.dispatch(new OrdersFilterSelected({ type: filterType, value: selectedOption }));

    private checkboxFilterChanged = (type: FilterType) => (e: ChangeEvent<HTMLInputElement>): void =>
        e.currentTarget.checked
            ? this.props.dispatch(new OrdersFilterSelected({ type, value: true }))
            : this.props.dispatch(new OrdersFilterRemoved({ type, value: true }));

    // tslint:disable:typedef
    private removeFilter = (filter: Filter) => (): void => this.props.dispatch(new OrdersFilterRemoved(filter));

    private onSearch = (value: string): void => {
        this.props.dispatch(new OrderProductsSearchRequested(value));
    };
}

const mapStateToProps = (state: State): StateProps => ({
    brand: state.products.brand,
    season: state.products.season,
    collaboration: state.products.collaboration,
    category: state.products.category,
    type: state.products.type,
    querySearch: state.order.searchQuery
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrdersToolbar);



// WEBPACK FOOTER //
// ./src/view/order/OrdersToolbar.tsx